'use strict';

var React = require('react');
var makeStyles = require('../../../DesignSystem/Styles/makeStyles.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var LinearProgress = require('../../../node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    progressBarRoot: {
      width: '100%',
      height: theme.spacing(1.25),
      marginTop: theme.spacing(0.5),
      borderRadius: theme.spacing(4)
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[300]
    },
    barColorPrimary: {
      backgroundColor: theme.palette.success.main
    },
    status: function status(_ref) {
      var isSavedFeatureEnabled = _ref.isSavedFeatureEnabled;
      return {
        color: theme.palette.grey[600],
        paddingRight: isSavedFeatureEnabled ? theme.spacing(1.5) : 0
      };
    }
  };
});

var StatusInfo = function StatusInfo(_ref2) {
  var status = _ref2.status,
      percentage = _ref2.percentage,
      isSavedFeatureEnabled = _ref2.isSavedFeatureEnabled;
  var classes = useStyles({
    isSavedFeatureEnabled: isSavedFeatureEnabled
  });
  var statusContent = React.useMemo(function () {
    switch (status) {
      case 'completed':
        return React__default["default"].createElement(Typography, {
          version: "v2",
          variant: "caption"
        }, "Completed");

      case 'in_progress':
        return React__default["default"].createElement(LinearProgress["default"], {
          variant: "determinate",
          classes: {
            root: classes.progressBarRoot,
            colorPrimary: classes.colorPrimary,
            barColorPrimary: classes.barColorPrimary
          },
          value: percentage
        });

      default:
        return React__default["default"].createElement(Typography, {
          version: "v2",
          variant: "caption"
        }, "Not Started");
    }
  }, [status, percentage]);
  return React__default["default"].createElement("div", {
    "data-testid": "CoachingUnit-status-info",
    className: classes.status
  }, statusContent);
};

module.exports = StatusInfo;
